<template>
  <div class="installation-3d">
    <header-box :title="title" :intro="intro"></header-box>
    <div class="installation-3d__innerwrap">
      <div class="installation-3d__3d-wrapper">
        
        <div class="installation-3d__3d-view" :style="view3dStyle">
          <div class="installation-3d__3d-close-rect" v-on:click="closeBullet"></div>
          <div class="installation-3d__bullets" :class="{ show: info }">
            <bullet
              :key="index"
              :index="index"
              v-for="(b, index) in contentBlocks3d"
              :x="b.x"
              :y="b.y"
            >
            </bullet>
          </div>
        </div>
        <div class="installation-3d__3d-blocks" ref="blocks3d" :class="{ hide: (selectedBullet === -1 || !info) }">
          <three-sixty-block
            :id="'block-' + index"
            v-for="(block, index) in contentBlocks3d"
            :key="index"
            :image="block.image"
            :video="block.video"
            :title="block.title"
            :content="block.content"
            v-on:close="closeBullet"
            v-on:click="openBullet(index)"
            :index="index + 1"
            :close="selectedBullet === index"
          />
        </div>
        <div class="installation-3d__3d-toggle" :class="{ hide: selectedBullet !== -1 }">
          <toggle-button v-if="!isMobile" :label="translations['threesixtyLabels']" align="left" @change="toggleInfo" v-model="info"></toggle-button>
        </div>
      </div>
      <div class="installation-3d__blocks">
        <market-block v-for="(block, index) in contentBlocks" :block="block" :key="index"/>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PrevNextNav from '@/components/PrevNextNav';
import HeaderBox from '@/components/HeaderBox';
import MarketBlock from '@/components/MarketBlock';
import Bullet from '@/components/Bullet';
import ThreeSixtyBlock from '@/components/ThreeSixtyBlock';
import ToggleButton from '@/components/ToggleButton';

const scrollToElement = require('scroll-to-element');
const scrollIntoView = require('scroll-into-view');


export default {
  name: 'installation-3d',
  components: { PrevNextNav, HeaderBox, MarketBlock, Bullet, ThreeSixtyBlock, ToggleButton },
  watch: {
    selectedBullet(newVal, oldVal) {
      const bullet = this.$el.querySelector(`#block-${this.selectedBullet}`);
      if (this.selectedBullet !== -1 && bullet) {
        scrollIntoView(bullet, {
          time: oldVal === '-1' ? 0 : 500,
          isScrollable: target => target.classList && target.classList.contains('installation-3d__3d-blocks'),
        });
      }
      scrollToElement(this.$refs.blocks3d, { duration: 500, align: 'top' });
    },
  },
  methods: {
    toggleInfo(val) {
      const params = this.$route.params;
      params.selectedBullet = -1;
      params.info = val ? 'info' : 'noinfo';

      this.$router.push({
        name: this.$route.name,
        params,
      });
    },
    closeBullet() {
      const params = this.$route.params;
      params.selectedBullet = -1;
      this.$router.push({
        name: this.$route.name,
        params,
      });
    },
    openBullet(index) {
      const params = this.$route.params;
      params.selectedBullet = index;
      this.$router.push({
        name: this.$route.name,
        params,
      });
    },
  },
  computed: {
    ...mapGetters(['page', 'selectedBullet', 'info', 'translations']),
    title() {
      return this.page.title;
    },
    intro() {
      return this.page.intro;
    },
    image() {
      return this.page.image;
    },
    contentBlocks3d() {
      return this.page.threedContentBlocks;
    },
    contentBlocks() {
      return this.page.contentBlocks;
    },
    mobileContentBlocks() {
      const contentBlocks = this.page.contentBlocks.slice();

      [].forEach.call(contentBlocks, (contentBlock, index) => {
        if (index % 2 === 1 && contentBlocks[index].type === 'image' && contentBlocks[index - 1].type === 'text') {
          const tempFirst = contentBlocks[index];
          const tempSec = contentBlocks[index - 1];
          contentBlocks[index] = tempSec;
          contentBlocks[index - 1] = tempFirst;
        }
      });

      return contentBlocks;
    },
    view3dStyle() {
      const style = {
        backgroundImage: `url('${this.image}')`,
      };
      const selectedBlock = this.selectedBullet >= 0 && this.contentBlocks3d[this.selectedBullet];
      if (selectedBlock) {
        style.transformOrigin = `${selectedBlock.x}% ${selectedBlock.y}%`;
        style.transform = `translate(-50%, -50%) translate(${28 - selectedBlock.x}%, ${50 - selectedBlock.y}%) scale(${selectedBlock.scale})`;
      }
      return style;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../../scss/helpers';

.installation-3d {
  @include page(false);

  &__3d-wrapper {
    width: 100%;
    position: relative;

    @include not-mobile {
      height: calc(100vh - 70px);
      overflow: hidden;
    }
  }

  &__3d-view {
    display: block;
    background-size: cover;
    background-position: center;

    @include mobile {
      display: block;

      &::before {
        content: '';
        display: block;
        padding-top: 1396/2048*100%;
      }
    }

    @include not-mobile {
      @include aspect-ratio-box-cover(2048/1396, 70px);
      transition: transform .45s, transform-origin .45s;
    }
  }

  &__3d-close-rect {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  &__bullets {
    display: none;
  
    @include not-mobile {
      display: block;
    }
  }

  &__3d-blocks {
    display: block;
    padding: 20px 20px 0;
    box-sizing: border-box;

    @include not-mobile {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      padding: 40px 40px 0;
      width: 44%;
      @include gradientBackground();
      overflow: auto;
      transition: transform .45s;
  
      &.hide {
        transform: translateX(100%);
      }
    }
  }

  &__3d-toggle {
    display: block;
    padding: 12px 20px 12px 0;
    background: $c_white;
    position: absolute;
    top: 20px;
    left: 20px;
    transition: opacity .45s;

    &.hide {
      opacity: 0;
      pointer-events: none;
    }
  }

  &__blocks {
    display: none;

    @include not-mobile {
      display: flex;
      flex-wrap: wrap;
      align-items: stretch;
      box-sizing: border-box;
      padding: 20px 0 0;
      padding: 40px 0;

      &--mobile {
        display: none;
      }

      @include landscape {
        display: flex;
        padding: 20px 0 0;

        &--mobile {
          display: none;
        }
      }
    }
    
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/Installation3d.vue